import { Link } from "react-router-dom";
import { categories } from "@/utils/catalog";

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-fill text-xl" />
              </span>
              <span className="font-heading text-base font-semibold text-foreground-950">
                黄色片免费看
              </span>
            </div>
            <p className="mt-4 max-w-[280px] text-sm leading-relaxed text-foreground-600">
              一个面向成年观众的免费影片资源聚合平台，用清晰的分类与筛选，帮你更快找到想看的内容。
            </p>
            <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
              <i className="ri-user-3-line" /> 仅限 18 岁以上用户浏览
            </span>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-950">
              <Link to="/category/movie" className="hover:text-primary-600">
                影片分类
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/category/${item.slug}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-950">
              <Link to="/about" className="hover:text-primary-600">
                关于与帮助
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600">
                  网站介绍
                </Link>
              </li>
              <li>
                <Link to="/about#feedback" className="text-sm text-foreground-600 hover:text-primary-600">
                  意见反馈
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-foreground-600 hover:text-primary-600">
                  影片搜索
                </Link>
              </li>
              <li>
                <Link to="/about#copyright" className="text-sm text-foreground-600 hover:text-primary-600">
                  版权声明
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-950">友情链接</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/category/documentary" className="text-sm text-foreground-600 hover:text-primary-600">
                  纪录片专区
                </Link>
              </li>
              <li>
                <Link to="/category/short" className="text-sm text-foreground-600 hover:text-primary-600">
                  短片放映厅
                </Link>
              </li>
              <li>
                <Link to="/category/animation" className="text-sm text-foreground-600 hover:text-primary-600">
                  动画幻想馆
                </Link>
              </li>
              <li>
                <Link to="/category/series" className="text-sm text-foreground-600 hover:text-primary-600">
                  剧集追更榜
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-foreground-500">
            © 2024 黄色片免费看 · 本站影片资料均为演示示例内容，不提供真实播放与下载服务。
          </p>
          <p className="text-xs text-foreground-500">
            内容仅供演示 · 请遵守当地法律法规 · 未成年人请勿浏览
          </p>
        </div>
      </div>
    </footer>
  );
}